module.exports = __webpack_public_path__ + "977fe0bd6c3bba38732f99457107300b.MP3";